import { compose, isObject, omitBy, mapValues } from 'lodash/fp'

export const omitByRecursively = (value, iteratee) => {
  return isObject(value)?
    compose(
      omitBy(iteratee),
      mapValues(v => omitByRecursively(v, iteratee))
    )(value):
    value
}


// WEBPACK FOOTER //
// ./src/utils/dynaHelp.js